import { BaseDto } from '@/shared/dtos/base-dto';

export class cajasDto extends BaseDto {
    public localizador !: string;
    public imagen !: string;
    public catidad_prodcutos !: number;
    public precio_medio !: number;
    public precio_caja_iva !: number;
    public precio_caja !: number;
    public valor_amazon !: number;
    public porcentaje !: number;
    public pallet_id !: number;
    public vendida !: boolean;
    public abierta !: boolean;
    public department !: string;
    public referencia !: string;
} 
